module.exports = __webpack_public_path__ + "img/icon_coldcall_2.798aca48.svg";